






































import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { NewDocumentEditor } from "./editors";
import {
  EmbeddedDocumentEditViewMixin,
} from "./mixins";

@Component({
  components: {
    FixedLoading,
    NewDocumentEditor,
    RequestedDocumentProcessor,
  },
})
export default class EmbeddedNewDocumentEditView extends Mixins(EmbeddedDocumentEditViewMixin) {
  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  formatId: number;

  @Prop({ default: null })
  formatName: string;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  $refs!: {
    processor: RequestedDocumentProcessor;
    newDocumentEditor: NewDocumentEditor;
  };

  mounted() {
    this.embeddedComponent = this.$refs.newDocumentEditor;
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  validateSelectedFormatWriteMethod(format: any): boolean {
    return this.validateFormatWriteMethod(format, false);
  }
}
